import { formatNumber } from '@witmetrics/utils/strings';

export const classes = {
  card: 'w-full mb-[11px] rounded-2xl border border-black/10 bg-white/[0.82] p-0 shadow-aurora-card transition hover:border-brand-accent/55 hover:shadow-row-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  flatCard:
    'w-full rounded-none border-0 border-b border-solid border-black/[0.06] bg-transparent p-0 shadow-none transition-colors hover:bg-black/[0.03] dark:border-white/[0.08] dark:hover:bg-white/[0.04]',
  header:
    'flex w-full items-start gap-[13px] px-4 py-[13px] text-left cursor-pointer',
  iconWrapper:
    'mt-px size-10 shrink-0 place-center rounded-xl bg-black/[0.05] dark:bg-white/[0.07]',
  icon: 'size-[21px] text-taupe-1 dark:text-mauve-3',
  content: 'grow min-w-0',
  titleWrapper: 'flex flex-wrap items-center gap-[9px]',
  title:
    'text-sm font-semibold text-taupe-3 hover:underline cursor-pointer outline-none dark:text-mauve-1',
  subtitle:
    'flex items-center gap-[9px] mt-1 text-xs text-taupe-2 dark:text-mauve-2',
  separator: 'opacity-50',
  total: 'font-semibold',
  chevron:
    'mt-[11px] size-[18px] shrink-0 text-taupe-1 transition-transform dark:text-mauve-3',
  chevronOpen: 'rotate-180',
};

export function formatCount(count: number) {
  return `${formatNumber(count)} product${count === 1 ? '' : 's'}`;
}
